var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.168 5.667a.834.834 0 111.667 0 .834.834 0 01-1.667 0zm0 2.5a.834.834 0 011.667 0v4.166a.834.834 0 01-1.667 0V8.167zm.833 7.5A6.674 6.674 0 012.335 9 6.674 6.674 0 019 2.333 6.675 6.675 0 0115.668 9a6.674 6.674 0 01-6.667 6.667zm0-15a8.333 8.333 0 100 16.666 8.333 8.333 0 000-16.666z",
    fill: "current"
  })));
}
export default SvgInfo;